import { Box, Stack } from "@justworkshr/milo-core";
import { ReactElement } from "react";
import styles from "../../InternationalSolutionsPage.module.css";
import { CF_INTERNATIONAL_SOLUTIONS_EMPLOYER_OF_RECORD_LINK } from "../../constants";

const LookingForEorCard = (): ReactElement => {
  const { hr, mdHead, smFont } = styles;
  return (
    <Box
      backgroundColor="neutral"
      border={{
        borderColor: "neutralSubtle",
        borderRadius: "md",
        borderWidth: "sm",
      }}
      padding="md"
    >
      <Stack spacing="md">
        <div className={mdHead}>Want to hire full-time employees?</div>
        <hr className={hr}></hr>
        <p className={smFont}>
          We support full-time international employees as an Employer of Record
          in key markets including Canada, India, Mexico, Spain, and the U.K.{" "}
          <a href={CF_INTERNATIONAL_SOLUTIONS_EMPLOYER_OF_RECORD_LINK}>
            <span className={smFont}>Learn more</span>
          </a>
        </p>
      </Stack>
    </Box>
  );
};

export default LookingForEorCard;
